import React from 'react';

const Receipt = () => {
    return (
        <>
            <h1>Takk for at du meldte din interesse</h1>
            <p>Du vil høre fra oss i løpet av 1-3 virkedager for en prat om forsikring.</p>
        </>
    );
};
export default Receipt;
